import { z } from 'zod';

// Lot schema definition
export const lotSchema = z.object({
  ma_lo: z.string().min(1, { message: 'Mã lô không được để trống' }),
  ten_lo: z.string().min(1, { message: 'Tên lô không được để trống' }),
  ten_lo2: z.string().nullable().optional(),
  ma_vt2: z.string().nullable().optional(),
  ngay_nhap: z.string().min(1, { message: 'Ngày nhập không được để trống' }),
  ngay_sx: z.string().min(1, { message: 'Ngày sản xuất không được để trống' }),
  ngay_hhsd: z.string().min(1, { message: 'Hạn sử dụng không được để trống' }),
  ngay_hhbh: z.string().min(1, { message: 'Ngày hết hạn bảo hành không được để trống' }),
  ghi_chu: z.string().nullable().optional(),
  status: z.string().nonempty('Trạng thái không được để trống')
});

export type LotFormattedData = z.infer<typeof lotSchema>;

export const initialLotValues: LotFormattedData = {
  ma_lo: '',
  ten_lo: '',
  ten_lo2: null,
  ma_vt2: null,
  ngay_nhap: new Date().toISOString().split('T')[0],
  ngay_sx: new Date().toISOString().split('T')[0],
  ngay_hhsd: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
  ngay_hhbh: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
  ghi_chu: '',
  status: '1'
};
